import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen pt-20 flex items-center justify-center bg-white">
      <div className="max-w-md mx-auto px-4 text-center">
        <div className="bg-[#F9F6F0] p-12 rounded-lg">
          <XCircle size={64} className="text-orange-600 mx-auto mb-6" />
          <h1 className="text-3xl font-serif text-[#1A1A1A] mb-4">
            Pagamento Annullato
          </h1>
          <p className="text-[#666666] mb-8 leading-relaxed">
            Il pagamento è stato annullato. Nessun addebito è stato effettuato.
          </p>
          <div className="flex flex-col gap-4">
            <Link
              to="/prenota"
              data-testid="back-booking-link"
              className="bg-[#2C5263] text-white px-8 py-3 rounded-md text-base font-medium hover:bg-[#1A3644] transition-colors"
            >
              Riprova Prenotazione
            </Link>
            <Link
              to="/"
              data-testid="back-home-link"
              className="text-[#2C5263] hover:text-[#1A3644] font-medium"
            >
              Torna alla Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
